module.exports = __webpack_public_path__ + "img/default-l-00b7ff.fe0a7da1.svg";